import MuiDialog from '@mui/material/Dialog';
import { alpha, hexToRgb } from '@mui/system';

import { styled } from '../helpers';

import { DialogProps } from './Dialog.types';

export const Dialog = styled(MuiDialog)<DialogProps>`
  .MuiDialog-paper {
    box-shadow: 0px 0px 8px rgba(34, 38, 72, 0.16);
  }

  .MuiBackdrop-root {
    background-color: ${({ theme }) => `${alpha(hexToRgb(theme.palette.secondary.contrastText), 0.4)}`};
  }
`;
// @ts-ignore
Dialog.displayName = 'Dialog';

export default Dialog;
